module.exports = __webpack_public_path__ + "static/img/service1.0a550ed4.png";